import { isDev, isLocal, isProduction } from '@/common/environment';
import { isMoveITTenant } from '@/common/Tenants';
import { SystemEnvironment } from '@/constants/systemEnviroment';

export const getSystemEnvironment = (): SystemEnvironment => {
  const searchParams = new URLSearchParams(window.location.search);
  let envParam: SystemEnvironment = searchParams.get(
    'env',
  ) as SystemEnvironment;
  if (isLocal || isDev) {
    return envParam ? envParam : SystemEnvironment.STAGING;
  } else if (isProduction) {
    if (isMoveITTenant()) {
      return envParam ? envParam : SystemEnvironment.PRODUCTION;
    } else {
      return SystemEnvironment.PRODUCTION;
    }
  } else {
    return SystemEnvironment.STAGING;
  }
};
